import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesLegacyClientsMain } from './modules/ui/Main';

const LegacyClientsPage = (
  <SuspensePage>
    <PagesLegacyClientsMain />
  </SuspensePage>
);

export default LegacyClientsPage;
